var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8477 11.2266H12.6377L17.6277 16.2266L16.1377 17.7166L11.1377 12.7266V11.9366L10.8677 11.6566C9.72769 12.6366 8.24769 13.2266 6.6377 13.2266C3.0477 13.2266 0.137695 10.3166 0.137695 6.72656C0.137695 3.13656 3.0477 0.226562 6.6377 0.226562C10.2277 0.226562 13.1377 3.13656 13.1377 6.72656C13.1377 8.33656 12.5477 9.81656 11.5677 10.9566L11.8477 11.2266ZM2.1377 6.72656C2.1377 9.21656 4.1477 11.2266 6.6377 11.2266C9.1277 11.2266 11.1377 9.21656 11.1377 6.72656C11.1377 4.23656 9.1277 2.22656 6.6377 2.22656C4.1477 2.22656 2.1377 4.23656 2.1377 6.72656Z",
    fill: "#C7C8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.43669afaecbf853db12bbe7d89a38282.svg";
export { ForwardRef as ReactComponent };